import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'shared-modal-for-dine-in',
    templateUrl: './modal-for-dine-in.shared.component.html',
    styleUrls: ['./modal-for-dine-in.shared.component.scss']
})
export class ModalForDineInComponent extends ModalViewComponent implements OnInit {
    private _form!: FormGroup;
    private _tableNo!: string;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';
        this._tableNo = this.modalData?.params?.tableNo || null;
    }

    public handleFormInit($event: FormGroup): void {
        this._form = $event;

        setTimeout(() => {
            this.handleHeightUpdate();
        }, 50);
    }

    public handleSkipClick($event: Event): void {
        this.controllers.collectionType.patchTableNoValue(null);
        this.close();
    }

    public handleStartOrderClick($event: Event): void {
        if (this.modalData?.params?.buzzer === false) {
            if (this._form) {
                this._tableNo = this._form.get('tableNumber').value;
            }

            this.controllers.collectionType.patchTableNoValue(this._tableNo);
        }


        this.close();
    }

    public get tableNo(): string {
        return this._tableNo || null;
    }

    public get isBuzzer(): boolean {
        return this.modalData?.params?.buzzer === true;
    }

    public get showTableForm(): boolean {
        return !this.isBuzzer && !this.tableNo;
    }

    public get isFormValid(): boolean {
        return this._form?.valid === true || this.tableNo !== null || this.isBuzzer;
    }

    public get imageUrl(): string {
        return this.modalData?.params?.img ? `/assets/images/dinein.${this.modalData?.params?.img}.svg` : null;
    }

    public get title$(): Observable<string> {
        if (this.showTableForm && !this.isBuzzer) {
            return of('Enter your table number');
        }

        return this.controllers.locations.locationFriendlyName$(this.modalData.locationNo)
            .pipe(
                map(locationName => `Welcome to ${locationName}`)
            );
    }

    public get preTitle(): string {
        return this.modalData.params?.preTitle || null;
    }

    public get description(): string[] {
        return this.modalData.params?.description || null;
    }

}
